
// import { createSlice } from "@reduxjs/toolkit";
// import { getSolarBrand } from "../reduxApi/SolarBrandReduxApi";

// const solarBrandSlice = createSlice({
//     name: 'solarBrand',
//     initialState: {
//         status: 'idel',
//         panel: [],
//     },
//     reducers: {
//         deleteSolarBrandAction: (state, action) => {
//             action.payload.forEach((ROWID) => {
//                 const index = state.solarBrand.findIndex((item) => item.ROWID === ROWID);
//                 if (index !== -1) {
//                     state.solarBrand.splice(index, 1);
//                 }
//             });
//         },
//         updateSolarBrandAction: (state, action) => {
//             // console.log("action", action.payload.ROWID)
//             const index = state.solarBrand.findIndex((item) => item.ROWID === action.payload.ROWID)
//             if (index != -1) {
//                 state.solarBrand.splice(index, 1, action.payload)
    
//             }
//         },
//         addSolarBrandAction: (state, action) => {
//             const temp = action.payload.formData;
//             console.log("temp", temp)
//             temp.ROWID = action.payload.ROWID;
//             console.log("temp111", temp)
//             state.solarBrand.unshift(temp);           
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getSolarBrand.pending, (state, action) => {
//             state.status = 'pending'
//         })
//             .addCase(getSolarBrand.fulfilled, (state, action) => {
//                 state.status = 'fulfilled'
//                 state.solarBrand = action.payload.data.solarBrand;
//             })
//     }
// })
// export const { deleteSolarBrandAction, updatePanelAction, addSolarBrandAction } = solarBrandSlice.actions
// export default solarBrandSlice.reducer


import { createSlice } from "@reduxjs/toolkit";
import { getSolarBrand } from "../reduxApi/SolarBrandReduxApi";

const solarBrandSlice = createSlice({
    name: 'solarBrand',
    initialState: {
        status: 'idel',
        solarBrand: [], // Fixed: changed 'panel' to 'solarBrand'
    },
    reducers: {
        deleteSolarBrandAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.solarBrand.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.solarBrand.splice(index, 1);
                }
            });
        },
        updateSolarBrandAction: (state, action) => {
            const index = state.solarBrand.findIndex((item) => item.ROWID === action.payload.ROWID);
            if (index !== -1) {
                state.solarBrand.splice(index, 1, action.payload);
            }
        },
        addSolarBrandAction: (state, action) => {
            const temp = { ...action.payload.formData }; // Create a copy
            temp.ROWID = action.payload.ROWID;
            state.solarBrand.unshift(temp);           
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSolarBrand.pending, (state, action) => {
                state.status = 'pending';
            })
            .addCase(getSolarBrand.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.solarBrand = action.payload.data.solarBrand;
            });
    }
});

// Fixed export - make sure you're exporting all actions
export const { deleteSolarBrandAction, updateSolarBrandAction, addSolarBrandAction } = solarBrandSlice.actions;
export default solarBrandSlice.reducer;